import { gql } from "lib/apolloClient";

export const copyUnitPlanMutation = gql`
  mutation copyUnitPlan($input: CopyUnitPlanInput!) {
    planner {
      copyUnitPlan(input: $input) {
        id
      }
    }
  }
`;

export const markSyncReadMutation = gql`
  mutation markSyncRead($input: [UpsertUserEntityStateInput!]!) {
    platform {
      upsertUserEntityState(input: $input) {
        isSuccess
      }
    }
  }
`;
